import { DevolutionDetailPrintModel } from "./devolution-detail-print.model";

export class DevolutionPrintModel {
  id: number = 0;
  devolutionId: number = 0;
  titleForm: string = "";
  enterpriseLogo: string | null = null;
  enterpriseNit: string = "";
  enterpriseName: string = "";
  branchName: string = "";
  consecutive: number = 0;
  branchAddress: string = "";
  branchPhone: string = "";
  dateDevolution: Date = new Date();
  datePredevolution: Date | null = new Date();
  dateInvoice: Date = new Date();
  advertiser: string = "";
  costCenter: string = "";
  constructionSiteAddress: string = "";
  constructionSitePhone: string = "";
  constructionSiteAlterPhone: string | null = null;
  clientName: string = "";
  clientPhone: string = "";
  clientAlterPhone: string | null = null;
  destinityCity: string = "";
  plateVehicle: string = "";
  wildcard: string = "";
  wildcard2: string = "";
  printObservation: string = "";
  devolutionObservation: string = "";
  transporter: string = "";
  transportValue: number = 0;
  userAuthenticated: string = "";
  devolutionDetails: DevolutionDetailPrintModel[] = [];
}